import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { StripeElementsOptions } from '@stripe/stripe-js';
import { BaseService, SettingsService, StorageService } from 'src/app/core/services';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { environment } from 'src/environment';
import { loadStripe } from '@stripe/stripe-js';
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import { Router } from '@angular/router';
import { SessionService } from 'src/app/core/services/session.service';

@Component({
  selector: 'app-change-ideal-info',
  templateUrl: './change-ideal-info.component.html',
  styleUrls: ['./change-ideal-info.component.scss']
})
export class ChangeIdealInfoComponent implements OnInit {

  idealBank: import("@stripe/stripe-js").StripeIdealBankElement;

  elementsOptions: StripeElementsOptions = {
    locale: 'en',
  };
  sessionId: any;
  @ViewChild('idealBankElement') idealBankElement: ElementRef;
  uId = '';
  idealEmptyError = true;
  proceedPayment = false;
  stripe;
  proceedToPay;
  region;
  locale;
  subsId;
  errorFound;
  errorResult;
  errRoute;
  skinName = environment.skinName;
  constructor(private storageService: StorageService, public configService: ConfigurationService,
              private settingsService: SettingsService, private baseService: BaseService,
              private subscriptionService: SubscriptionService, private router: Router,
              private sessionService: SessionService) {
    this.uId = this.storageService.getLocalStore('u_id');
    this.elementsOptions.locale = this.configService.stripeLocaleCode;
    this.region = storageService.getLocalStore('region');
    this.locale = storageService.getLocalStore('locale');
  }

  ngOnInit(): void {
    let textColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-font-color-on-lbg');
    let bgColor =  getComputedStyle(document.documentElement).getPropertyValue('--bg-page');
    let placeHolderColor = getComputedStyle(document.documentElement).getPropertyValue('--secondary-font-color');
    const options = {
      style: {
        base: {
          padding: '10px 12px',
          color: textColor,
          fontSize: '16px',
          backgroundColor: bgColor,
          lineHeight: '0.9',
          '::placeholder': {
            color: placeHolderColor
          },
        },
      },
    };
    const publishableKey = this.settingsService.stripeKey;
    loadStripe(publishableKey).then(res => {
      this.stripe = res;
      const stripeElement = this.stripe.elements({locale: this.elementsOptions.locale});
      this.idealBank = stripeElement.create('idealBank', options);
      this.idealBank.mount('#ideal-bank-element');
      this.idealBank.on('change', (event) => {
        this.idealEmptyError = event['empty'];
      });
    });
    this.setSesssionId();
  }

  setSesssionId() {
    this.subscriptionService.updateMethodApi().subscribe((data) => {
      if (data) {
        this.sessionId = data.session_id;
      }
      this.baseService.loaderSource.next(false)
    });
  }


  validateSession(){
    this.sessionService.validateSession(this.sessionId).subscribe((resp) => {
      if (resp.status_code === 200) {
      const data = resp.data;
      this.subsId = data.session?.subscription_id;
      this.errorFound = (data.already_subscribed || data.expired || data.invalid);
      this.errorResult = {
        already_subscribed: data.already_subscribed, expired: data.expired, invalid: data.invalid
      };
      if (this.errorFound) {
        this.baseService.loaderSource.next(false);
        this.navErrPage();
      }} else {
        this.errorResult = {
          already_subscribed: false, expired: false, invalid: true
        };
        this.navErrPage();
        this.baseService.loaderSource.next(false);
      }
    })
  }

  navErrPage() {
    switch (true) {
      case (this.errorResult.already_subscribed):
        this.router.navigate([`${this.errRoute}`, 'susbcribed']);
        break;
      case (this.errorResult.expired):
        this.router.navigate([`${this.errRoute}`, 'expired']);
        break;
      case (this.errorResult.invalid):
        this.router.navigate([`${this.errRoute}`, 'invalid']);
        break;
      default:
        this.router.navigate([`${this.errRoute}`, 'invalid']);
        break;
    }
  }

  idealPayItem(): void{
    const updateIdealPayData = { region: this.region, locale: this.locale, session_id: this.sessionId };
    this.subscriptionService.idealPayment(updateIdealPayData).subscribe(res => {
      if (res.status) {
        const clientSecretKey = res.intent?.client_secret;
        const userContent = res.user;
        this.confirmIdealSetup(clientSecretKey, userContent);
      } else {
        this.baseService.loaderSource.next(false);
      }
    });
  }
  async confirmIdealSetup(clientSecretKey: string, user) {
    const region = this.storageService.getLocalStore('region');
    const locale = this.storageService.getLocalStore('locale');
    const returnURL = `${environment.routeUrl + region +'/payment/update/method/success'}?stripe_type=ideal&session_id=${this.sessionId}&region=${region}&locale=${locale}`;
    const paymentData = {
      payment_method: {
        ideal: this.idealBank,
        billing_details: {
          name: user.name,
          email: user.email
        },
      },
      return_url: returnURL
    };
    await this.stripe.confirmIdealSetup(clientSecretKey, paymentData)
    this.baseService.loaderSource.next(false);
  }

  payment(event) {
    this.baseService.loaderSource.next(true);
    event.preventDefault();
    this.proceedPayment = true;
    if (!this.idealEmptyError) {
      this.proceedToPay = true;
      this.idealPayItem();
    } else {
      this.proceedToPay = false;
      this.baseService.loaderSource.next(false);
    }
  }

}
